import {useCallback, useSyncExternalStore} from 'react'

type Listener = () => void

const stores = new Map<string, {
    listeners: Listener[]
    subscribe: (listener: Listener) => () => void
    getSnapshot: () => boolean
    toggle: () => void
}>()

function getOrCreateStore(key: string) {
    if (!stores.has(key)) {
        let listeners: Listener[] = []

        const emitChange = () => listeners.forEach(l => l())

        stores.set(key, {
            listeners,
            subscribe: (listener: Listener) => {
                listeners = [...listeners, listener]
                stores.get(key)!.listeners = listeners
                return () => {
                    listeners = listeners.filter(l => l !== listener)
                    stores.get(key)!.listeners = listeners
                }
            },
            getSnapshot: () => localStorage.getItem(key) === 'true',
            toggle: () => {
                const next = localStorage.getItem(key) !== 'true'
                localStorage.setItem(key, String(next))
                emitChange()
            },
        })
    }
    return stores.get(key)!
}

const serverSnapshot = false
const getServerSnapshot = () => serverSnapshot

export function useCollapsible(storageKey: string): [boolean, () => void] {
    const store = getOrCreateStore(storageKey)

    const collapsed = useSyncExternalStore(
        store.subscribe,
        store.getSnapshot,
        getServerSnapshot,
    )

    return [collapsed, store.toggle]
}

export const useSidebarCollapsed = () => useCollapsible('sidebar-collapsed')
export const useRightSidebarCollapsed = () => useCollapsible('right-rail-collapsed')
